import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GsLoginService } from './gs-login.service';

@Component({
  selector: 'lib-gs-login',
  template: `
  <div class="login">
  <h1>Login to Web App</h1>
  <form [formGroup]="loginForm">
    <p><input type="text" name="login" formControlName="username" placeholder="Username"></p>
    <p><input type="password" name="password" formControlName="password" placeholder="Password"></p>
    <p class="submit">
    <input type="submit" (click)="onSubmit()" name="commit" value="Login"></p>
  </form>
</div>

  `,
  styles: [
  ],
  styleUrls:['./gs-login.component.css']
})
export class GsLoginComponent implements OnInit {

  loginForm=new FormGroup({
    username:new FormControl('',[Validators.required]),
    password:new FormControl('',[Validators.required])
  })
  constructor(private gsLoginservice:GsLoginService) { }

  ngOnInit(): void {
  }

  onSubmit(){
    this.gsLoginservice.login(this.loginForm.value);
  }

}
